import React from 'react';
import './Dialog.css';

export const Dialog = ({ open, onOpenChange, children }) => {
  const trigger = React.Children.toArray(children).find(
    child => child.type === DialogTrigger
  );
  const content = React.Children.toArray(children).find(
    child => child.type === DialogContent
  );

  return (
    <>
      {trigger && React.cloneElement(trigger, { onOpenChange })}
      {open && (
        <div className="dialog-overlay" onClick={(e) => {
          if (e.target === e.currentTarget) {
            onOpenChange(false);
          }
        }}>
          <div className="dialog-content" onClick={(e) => e.stopPropagation()}>
            {content}
          </div>
        </div>
      )}
    </>
  );
};

export const DialogTrigger = ({ asChild, children, onOpenChange, ...props }) => {
  const handleClick = () => {
    if (onOpenChange) {
      onOpenChange(true);
    }
  };

  if (asChild && React.isValidElement(children)) {
    return React.cloneElement(children, {
      ...props,
      onClick: handleClick
    });
  }

  return <button {...props} onClick={handleClick}>{children}</button>;
};

export const DialogContent = ({ children, className = '' }) => {
  return <div className={`dialog-inner ${className}`}>{children}</div>;
};

export const DialogHeader = ({ children, className = '' }) => {
  return <div className={`dialog-header ${className}`}>{children}</div>;
};

export const DialogTitle = ({ children, className = '' }) => {
  return <h2 className={`dialog-title ${className}`}>{children}</h2>;
};

export const DialogDescription = ({ children, className = '' }) => {
  return <p className={`dialog-description ${className}`}>{children}</p>;
};
